import React, { useState, useEffect } from "react";
import Modal from "react-modal";
import { MessageSquareText, X, CheckCircle2 } from "lucide-react";

const FeedbackModal = ({ isOpen, onClose, onSubmit }) => {
  const [feedback, setFeedback] = useState("");

  // --- Reset mező bezáráskor ---
  useEffect(() => {
    if (!isOpen) {
      const timeout = setTimeout(() => setFeedback(""), 200);
      return () => clearTimeout(timeout);
    }
  }, [isOpen]);

  // --- Keyboard shortcuts (Ctrl+Enter = save, Esc = close) ---
  useEffect(() => {
    const handleKey = (e) => {
      if (!isOpen) return;

      if (e.key === "Escape") {
        e.preventDefault();
        onClose();
      }

      if (e.ctrlKey && e.key === "Enter") {
        e.preventDefault();
        handleSave();
      }
    };

    window.addEventListener("keydown", handleKey);
    return () => window.removeEventListener("keydown", handleKey);
  }, [isOpen, feedback]);

  const handleSave = () => {
    // feedback most már nem kötelező
    onSubmit(feedback.trim() || null);
  };

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onClose}
      className={`p-8 rounded-2xl max-w-lg mx-auto mt-32 outline-none transition-all duration-300 shadow-xl border 
    ${document.documentElement.classList.contains("dark")
          ? "bg-gradient-to-b from-gray-900 to-gray-950 text-gray-100 border-gray-700 shadow-[0_0_25px_rgba(0,0,0,0.5)]"
          : "bg-gradient-to-b from-white to-gray-50 text-gray-900 border-gray-400 shadow-[0_0_20px_rgba(0,0,0,0.1)]"
        }`}
      overlayClassName={`fixed inset-0 flex justify-center items-start z-50 backdrop-blur-sm transition-colors duration-300 
    ${document.documentElement.classList.contains("dark") ? "bg-black/70" : "bg-gray-900/40"}`}
    >
      {/* HEADER */}
      <div className={`flex items-center justify-between mb-6 border-b pb-3 
    ${document.documentElement.classList.contains("dark") ? "border-gray-700" : "border-gray-300"}`}>
        <h3 className={`text-2xl font-semibold flex items-center gap-2 
      ${document.documentElement.classList.contains("dark") ? "text-blue-400" : "text-blue-600"}`}>
          <MessageSquareText className="w-6 h-6" />
          Introdu feedback-ul pentru finalizare
        </h3>
        <button
          onClick={onClose}
          className={`transition flex items-center gap-1 
        ${document.documentElement.classList.contains("dark")
              ? "text-gray-400 hover:text-gray-200"
              : "text-gray-500 hover:text-gray-700"}`}
        >
          <X className="w-5 h-5" />
          <span className="text-xs opacity-70">(Esc)</span>
        </button>
      </div>

      {/* BODY */}
      <div>
        <textarea
          placeholder="Scrie un feedback scurt... (opțional)"
          value={feedback}
          onChange={(e) => setFeedback(e.target.value)}
          className={`w-full border rounded-xl px-4 py-3 text-[15px] leading-relaxed transition outline-none resize-y 
        focus:ring-2 focus:ring-blue-500 custom-scrollbar
        ${document.documentElement.classList.contains("dark")
              ? "bg-gray-800 border-gray-600 text-gray-100 placeholder-gray-500 focus:bg-gray-800/90"
              : "bg-gray-50 border-gray-400 text-gray-900 placeholder-gray-600 focus:bg-white focus:border-blue-400"
            }`}
          style={{ minHeight: "140px", lineHeight: "1.6" }}
        />
      </div>

      {/* FOOTER */}
      <div className={`flex justify-center gap-4 mt-8 border-t pt-4 
    ${document.documentElement.classList.contains("dark") ? "border-gray-700" : "border-gray-300"}`}>
        <button
          onClick={onClose}
          className={`flex-1 px-4 py-2.5 rounded-lg font-medium transition flex items-center justify-center gap-2
        ${document.documentElement.classList.contains("dark")
              ? "bg-gray-600 hover:bg-gray-500 text-white"
              : "bg-gray-300 hover:bg-gray-400 text-gray-900"
            }`}
        >
          <X className="w-4 h-4" />
          <span>Anulare</span>
          <span className="text-xs opacity-70">(Esc)</span>
        </button>

        <button
          onClick={handleSave}
          className={`flex-1 px-4 py-2.5 rounded-lg font-medium flex items-center justify-center gap-2 shadow-md hover:shadow-lg transition
        ${document.documentElement.classList.contains("dark")
              ? "bg-blue-700 hover:bg-blue-600 text-white"
              : "bg-blue-600 hover:bg-blue-700 text-white"
            }`}
        >
          <CheckCircle2 className="w-5 h-5" />
          <span>Salvează</span>
          <span className="text-xs opacity-70">(Ctrl + Enter)</span>
        </button>
      </div>
    </Modal>

  );
};

export default FeedbackModal;
